import React from "react";
import { Helmet } from "react-helmet-async";
import "./DeleteAccount.css";

const DeleteAccount = () => {
  return (
    <div className="delete-page">
      <Helmet>
        <title>Delete Account Request | DOR Dress On Rent</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="delete-container">

        <div className="logo-section">
          <h1>DOR</h1>
          <p>Account & Data Deletion Request</p>
        </div>

        <p className="intro-text">
          Users of the DOR application can request deletion of their account
          and associated personal data at any time.
        </p>

        <div className="section">
          <h2>How to Request Account Deletion</h2>

          <p>
            To request deletion of your account, please send an email to:
          </p>

          <div className="email-box">
            <a href="mailto:borezydev@gmail.com">
              borezydev@gmail.com
            </a>
          </div>

          <p>Please include the following details:</p>

          <ul>
            <li>Registered phone number</li>
            <li>Registered email address (if applicable)</li>
            <li>Your full name</li>
          </ul>
        </div>

        <div className="section">
          <h2>Data That Will Be Deleted</h2>

          <ul>
            <li>User profile information</li>
            <li>Saved addresses</li>
            <li>Authentication records</li>
            <li>Order / booking history</li>
            <li>App usage related personal data</li>
          </ul>
        </div>

        <div className="section">
          <h2>Data Retention</h2>

          <p>
            Certain transactional or legal records may be retained for a
            limited period if required by law or regulatory obligations.
          </p>
        </div>

        <div className="section">
          <h2>Processing Time</h2>

          <p>
            Account deletion requests are processed within 7 business days.
          </p>
        </div>

        <div className="footer">
          © 2026 DOR. All rights reserved.
        </div>

      </div>
    </div>
  );
};

export default DeleteAccount;